import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function GuaranteeSection() {
  return <section id="guarantee" className="py-16 md:py-24 px-4 relative overflow-hidden" data-id="element-40">
      {/* Subtle calm background glow */}
      <div className="absolute inset-0 bg-calm/5 -z-10" data-id="element-41"></div>

      <div className="max-w-3xl mx-auto text-center" data-id="element-42">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7
      }} className="bg-base/80 backdrop-blur-sm border border-calm/30 rounded-3xl p-8 md:p-12 shadow-xl" data-id="element-43">
          <div className="flex justify-center mb-6" data-id="element-44">
            <div className="bg-calm/10 p-5 rounded-full text-calm" data-id="element-45">
              <ShieldCheckIcon size={48} strokeWidth={1.5} data-id="element-46" />
            </div>
          </div>

          <h2 className="text-3xl md:text-4xl font-serif font-bold text-main mb-6" data-id="element-47">
            Garantía de "Paz Mental" de 7 Días
          </h2>

          <p className="text-lg md:text-xl text-muted leading-relaxed mb-8" data-id="element-48">
            Probá el método. Si en 7 días no sentís que recuperaste el control
            de tu respiración y tu sueño, te devolvemos el 100% de tu dinero.{' '}
            <strong className="text-calm font-semibold" data-id="element-49">
              El riesgo es todo mío.
            </strong>
          </p>

          <p className="text-sm text-muted opacity-70 tracking-wide pt-6 border-t border-white/10" data-id="element-50">
            Acceso inmediato · Pago único y seguro
          </p>
        </motion.div>
      </div>
    </section>;
}